
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SuluBlock } from '@/logic/cms/sulu';

@Component
export default class VideoBlock extends Vue {
  @Prop(Object)
  block!: SuluBlock[];
}
